import React from 'react';

import { Html } from 'components/Html.jsx';
import { Users } from 'models/UserCollection';
import { ChatRoom } from '../models/ChatRoom';


import AutolinkedTextComponent, { autolinkedTextDefaultProps } from '../react/elements/AutolinkedTextComponent';
import MessageParser from "./MessageParser";
import { getMyUsernameRegex } from "./contstants/CommonRegularExpressions";
import './StringCheats';

export class LadderLinker {
	static autoReplaces = {};
	static flippedAutoReplaces = null;

	static emoteShortcuts = {};
	static emoteShortcutsEntries = null;

	static autolinkerOptions = {};

	static reactAutolinkMessage(message) {
		const messageParser = new MessageParser();
		return {
			messageReact: LadderLinker.autolinkMessage(message, true, messageParser),
			messageParser
		};
	}

	static autolinkMessage(message, reactComponents = false, messageParser = null) {
		LadderLinker.autolinkerOptions.stripPrefix = false;
		LadderLinker.autolinkerOptions.hashtag = 'twitter';

		if(reactComponents) {
			const props = {
				messageParser: messageParser || new MessageParser(),
				options: LadderLinker.autolinkerOptions,
				text: message.message,
				linkedRooms: message.linkedRooms || null,
				// Read when parsing: the sender may be set after the text.
				authoredByMe: () => !!message.player && typeof message.player.isMe === 'function' && message.player.isMe(),
			};
			// Parse with the component's defaults (linkText) now, so casual
			// mentions are known before the first render, not only after it.
			props.messageParser.updateProps({ ...autolinkedTextDefaultProps, ...props });
			return <AutolinkedTextComponent
				{...props}
			/>;
		}

		let text = Autolinker.link(Html.encode(message.message), LadderLinker.autolinkerOptions);

		$.each(LadderLinker.autoReplaces, function(search, replace) {
			var regex = new RegExp(search, 'g');
			if(replace.link) {
				text = text.replace(regex, '<a target="_blank" href="' + replace.link + '">' + search + '</a>');
			}
		});
		//Search for plain userna
		if(getMyUsernameRegex().test(text)) {
			text = text.replace(getMyUsernameRegex(), function(match) {
				return myUser.createUsernameElement()
					.addClass('casual_mention')
					.attr('title', 'You have been casually mentioned!')
					.text(match).attr('data-username', myUser.username).prop('outerHTML');
			});
		}

		return text;
	}

	static getGuideShortcuts() {
		if(LadderLinker.flippedAutoReplaces) {
			return LadderLinker.flippedAutoReplaces;
		}


		LadderLinker.flippedAutoReplaces = [];
		const temporaryArray = [];

		$.each(LadderLinker.autoReplaces, function(key, data) {
			if(LadderLinker.autoReplaces.hasOwnProperty(key)) {
				temporaryArray.push({
					shortcut: key,
					value: data
				});
			}
		});
		return LadderLinker.flippedAutoReplaces = temporaryArray;
	}

	static getEmoteShortcuts() {
		if(LadderLinker.emoteShortcutsEntries) {
			return LadderLinker.emoteShortcutsEntries;
		}
		LadderLinker.emoteShortcutsEntries = [];
		for(let shortcut in LadderLinker.emoteShortcuts) {
			if(!LadderLinker.emoteShortcuts.hasOwnProperty(shortcut)) {
				continue;
			}
			LadderLinker.emoteShortcutsEntries.push({
				type: 'emote',
				shortcut: shortcut,
				value: LadderLinker.emoteShortcuts[shortcut],
			});
		}
		return LadderLinker.emoteShortcutsEntries;
	};

	static autolinkUrl(tag, match) {
		let url = match.getUrl();
		var parsed = LadderLinker.parse_url(url);
		let location = null;
		if(!parsed.host) {
			parsed.host = '';
		}
		if(url.indexOf('i.imgur.com/') !== -1 ||
			url.indexOf('puu.sh/') !== -1
		// url.indexOf('prntscr.com/') doesn't support previews
		) {
			let imageMovieExtensions = {
				'gifv': true,
				'webm': true,
			};
			const fileExt = getExtensionFromUrl(url);
			let previewUrl = null;
			if(url.match('^http://')) {
				url = url.replace('http://', 'https://');
			}
			if(imageMovieExtensions[fileExt]) {
				previewUrl = url.replace(/\.[^/.]+$/, '');
				previewUrl = previewUrl + '.png';
				tag.setAttr('data-preview', previewUrl);
			}
			if(fileExt) {
				tag.setAttr('data-preview_url', url);
			}
			else {
				previewUrl = url + '.png';
				tag.setAttr('data-preview_url', previewUrl);
			}

			tag.addClass('streamlink');
			tag.addClass('imagelink');
			tag.setAttr('title', 'Click to preview image');
			tag.setTagName('a');
			tag.setAttr('data-stream_type', 'image');

			if(url.match('^http://')) {
				url = url.replace('http://', 'https://');
				tag.setAttr('href', url);
				tag.setInnerHtml(url);
			}
			return tag;
		}
		else if(parsed.host.indexOf('twitch.tv') !== -1
			&& !url.includes('twitch.tv/videos') && !url.includes('clips.twitch')) {
			location = LadderLinker.getLastUrlPart(url);

			tag.addClass('streamlink');
			tag.setAttr('title', 'Open embeded twitch stream - ' + location);
			tag.setTagName('a');
			tag.setAttr('data-literal', 't~' + location);
			tag.setAttr('data-channel_name', location);
			tag.setAttr('data-stream_type', 'twitch');

			return tag;
		}
		else if(parsed.host.indexOf('youtu.be') !== -1
			&& parsed.path) {
			location = LadderLinker.parseYoutubeVideoId(parsed.path);
			if(!location) {
				return;
			}
			tag.addClass('streamlink');
			tag.addClass('youtubelink');
			tag.setAttr('title', 'Open embeded youtube video - ' + location.id);
			tag.setTagName('a');
			tag.setAttr('data-literal', 'y~' + location.id);
			tag.setAttr('data-id', location.id);
			tag.setAttr('data-params', decodeURI(location.params));
			tag.setAttr('data-stream_type', 'youtube');

			return tag;
		}
		else if(parsed.host.indexOf('youtube.com') !== -1
			&& parsed.path === '/watch') {
			location = LadderLinker.parseYoutubeVideoId(url);
			if(!location) {
				return;
			}

			tag.addClass('streamlink');
			tag.addClass('youtubelink');
			tag.setAttr('title', 'Open embeded youtube video - ' + location.id);
			tag.setTagName('a');
			tag.setAttr('data-literal', 'y~' + location.id);
			tag.setAttr('data-id', location.id);
			tag.setAttr('data-params', decodeURI(location.params));
			tag.setAttr('data-stream_type', 'youtube');

			return tag;
		}
		else if(url.indexOf('smashladder') !== -1 && url.indexOf('/netplay/') !== -1) {
			const chatId = LadderLinker.getLastUrlPart(url);

			tag.addClass('chatlink');
			if(/^\d+$/.test(chatId)) {
				// Drawn as the room's chip, like a <#id> token (MessageParser).
				tag.roomLinkId = Number.parseInt(chatId, 10);
			}
			tag.setAttr('title', 'Open chat room');
			tag.setTagName('a');
			tag.setAttr('data-id', decodeURIComponent(chatId));

			const chat = ChatRoom.retrieve({ id: chatId });
			if(chat) {
				tag.innerHtml = `Go To - ${Html.encode(chat.name)}`;
			}
			else {
				tag.innerHtml = `Go To Chat Room with id - ${Html.encode(chatId)}`;
			}

			return tag;
		}
		else {
			tag.setAttr('title', url);
			tag.addClass('rawlink');

			const pattern = /^((http|https):\/\/)/;
			let innerToUse = String(tag.innerHtml);
			if(!pattern.test(innerToUse)) {
				innerToUse = url.replace(/^https?:\/\//, '');
			}

			tag.innerHtml = innerToUse.middleTruncate(64);
		}
		return tag;
	}

	// A hex color code gets its swatch class; any other #word stays plain text
	// (rooms are linked with <#id> tokens, not by name). Returns null for text.
	static autolinkHashtag(tag, match) {
		const hashtag = match.getHashtag();

		if(/^#?[0-9A-F]{6}$/i.test(hashtag)) {
			tag.addClass('hexcode');
			tag.setTagName('span');
			delete tag.attrs.href;
			delete tag.attrs.target;
			return tag;
		}
		return null;
	}

	static autolinkUsername(tag, match) {
		var twitterHandle = match.getTwitterHandle();
		var user = Users.retrieveByUsername(twitterHandle);

		tag.addClass(Array.from(user.cssUsername().keys()).join(' '));

		tag.setAttr('href', user.getProfileUrl());
		tag.player = user;
		tag.setAttr('data-username', twitterHandle);
		if(user.id !== undefined) {
			tag.setAttr('data-id', user.id);
		}
		return tag;
	}
}

function getExtensionFromUrl(url) {
	let extension = url.match(/\.([^\./\?]+)($|\?)/);
	if(!extension) {
		return null;
	}
	if(!extension[1]) {
		return null;
	}
	return extension[1];
}

LadderLinker.autolinkerOptions.replaceFn = function(autolinker, match) {
	var tag = autolinker.getTagBuilder().build(match);
	tag.addClass('autolinked');
	tag.setInnerHtml(match.getMatchedText());
	var location;
	switch(match.getType()) {
		case 'url':
			return LadderLinker.autolinkUrl(tag, match);
		case 'hashtag':
			return LadderLinker.autolinkHashtag(tag, match) || false;
		case 'email':
			return tag;
		case 'twitter':
			return LadderLinker.autolinkUsername(tag, match);

	}
	return tag;
};

LadderLinker.getLastUrlPart = function(str) {
	var split = str.split('/');
	var test = split.pop();
	if(test) {
		return test;
	}
	else {
		return split.pop();
	}
};
LadderLinker.addParameter = function(url, param, value) {
	var val = new RegExp('(\\?|\\&)' + param + '=.*?(?=(&|$))'),
		parts = url.toString().split('#'),
		url = parts[0],
		hash = parts[1];
	var qstring = /\?.+$/,
		newURL = url;

	// Check if the parameter exists
	if(val.test(url)) {
		// if it does, replace it, using the captured group
		// to determine & or ? at the beginning
		newURL = url.replace(val, '$1' + param + '=' + value);
	}
	else if(qstring.test(url)) {
		// otherwise, if there is a query string at all
		// add the param to the end of it
		newURL = url + '&' + param + '=' + value;
	}
	else {
		// if there's no query string, add one
		newURL = url + '?' + param + '=' + value;
	}

	if(hash) {
		newURL += '#' + hash;
	}

	return newURL;
};

LadderLinker.parse_url = function(str, component) {
	//       discuss at: http://phpjs.org/functions/parse_url/
	//      original by: Steven Levithan (http://blog.stevenlevithan.com)
	// reimplemented by: Brett Zamir (http://brett-zamir.me)
	//         input by: Lorenzo Pisani
	//         input by: Tony
	//      improved by: Brett Zamir (http://brett-zamir.me)
	//             note: original by http://stevenlevithan.com/demo/parseuri/js/assets/parseuri.js
	//             note: blog post at http://blog.stevenlevithan.com/archives/parseuri
	//             note: demo at http://stevenlevithan.com/demo/parseuri/js/assets/parseuri.js
	//             note: Does not replace invalid characters with '_' as in PHP, nor does it return false with
	//             note: a seriously malformed URL.
	//             note: Besides function name, is essentially the same as parseUri as well as our allowing
	//             note: an extra slash after the scheme/protocol (to allow file:/// as in PHP)
	//        example 1: parse_url('http://username:password@hostname/path?arg=value#anchor');
	//        returns 1: {scheme: 'http', host: 'hostname', user: 'username', pass: 'password', path: '/path', query: 'arg=value', fragment: 'anchor'}
	//        example 2: parse_url('http://en.wikipedia.org/wiki/%22@%22_%28album%29');
	//        returns 2: {scheme: 'http', host: 'en.wikipedia.org', path: '/wiki/%22@%22_%28album%29'}
	//        example 3: parse_url('https://host.domain.tld/a@b.c/folder')
	//        returns 3: {scheme: 'https', host: 'host.domain.tld', path: '/a@b.c/folder'}
	//        example 4: parse_url('https://gooduser:secretpassword@www.example.com/a@b.c/folder?foo=bar');
	//        returns 4: { scheme: 'https', host: 'www.example.com', path: '/a@b.c/folder', query: 'foo=bar', user: 'gooduser', pass: 'secretpassword' }

	var query;
	var mode = 'php';
	var key = [
		'source',
		'scheme',
		'authority',
		'userInfo',
		'user',
		'pass',
		'host',
		'port',
		'relative',
		'path',
		'directory',
		'file',
		'query',
		'fragment'
	];
	var parser = {
		php: /^(?:([^:\/?#]+):)?(?:\/\/()(?:(?:()(?:([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?))?()(?:(()(?:(?:[^?#\/]*\/)*)()(?:[^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
		strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
		loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/\/?)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/ // Added one optional slash to post-scheme to catch file:/// (should restrict this)
	};

	var m = parser[mode].exec(str);
	var uri = {};
	var i = 14;

	while(i--) {
		if(m[i]) {
			uri[key[i]] = m[i];
		}
	}

	if(component) {
		return uri[component.replace('PHP_URL_', '')
			.toLowerCase()];
	}

	if(mode !== 'php') {
		var name = (ini['phpjs.parse_url.queryKey'] &&
			ini['phpjs.parse_url.queryKey'].local_value) || 'queryKey';
		parser = /(?:^|&)([^&=]*)=?([^&]*)/g;
		uri[name] = {};
		query = uri[key[12]] || '';
		query.replace(parser, function($0, $1, $2) {
			if($1) {
				uri[name][$1] = $2;
			}
		});
	}

	delete uri.source;
	return uri;
};
LadderLinker.parseYoutubeVideoId = function(url) {
	var video_id;
	if(url.indexOf('v=') !== -1) {
		video_id = url.split('v=').pop();
	}
	else {
		video_id = LadderLinker.getLastUrlPart(url);
	}
	var ampersandPosition = video_id.indexOf('&');
	if(ampersandPosition === -1) {
		ampersandPosition = video_id.indexOf('?');
	}

	var params = video_id.substring(ampersandPosition, video_id.length);
	if(ampersandPosition !== -1) {
		video_id = video_id.substring(0, ampersandPosition);
	}
	if(!video_id) {
		return null;
	}
	return {
		id: video_id,
		params: params
	};
};